<template>
    <component :is="component">
        <slot />
    </component>
</template>

<style>
@font-face {
    font-family: 'regularFont';
    src: url('./assets/fonts/neris-light.otf') format('opentype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldFont';
    src: url('./assets/fonts/neris-black.otf') format('opentype');
    font-weight: bold;
}

@font-face {
    font-family: 'lightMontserratFont';
    src: url('./assets/fonts/montserrat-light.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'mediumMontserratFont';
    src: url('./assets/fonts/montserrat-medium.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularMontserratFont';
    src: url('./assets/fonts/montserrat-regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldMontserratFont';
    src: url('./assets/fonts/montserrat-bold.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularRobotoFont';
    src: url('./assets/fonts/roboto-regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldRobotoFont';
    src: url('./assets/fonts/roboto-bold.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularMyriadProFont';
    src: url('./assets/fonts/myriadpro-regular.otf') format('opentype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldMyriadProFont';
    src: url('./assets/fonts/myriadpro-bold.otf') format('opentype');
    font-weight: bold;
}

@font-face {
    font-family: 'boldAntomFont';
    src: url('./assets/fonts/antom-bold.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularPoppinsFont';
    src: url('./assets/fonts/poppins-regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldPoppinsFont';
    src: url('./assets/fonts/poppins-bold.ttf') format('truetype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularStaraFont';
    src: url('./assets/fonts/stara-regular.otf') format('opentype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldStaraFont';
    src: url('./assets/fonts/stara-bold.otf') format('opentype');
    font-weight: bold;
}

@font-face {
    font-family: 'regularCustom1Font';
    src: url('./assets/fonts/poppins2-regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'boldCustom1Font';
    src: url('./assets/fonts/trajan-bold.otf') format('opentype');
    font-weight: bold;
}

body {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
}

.application {
    font-family: regularFont;
    background: transparent !important;
    font-size: 14px;
}

.swal2-container {
    font-family: regularFont;
}

.text-bold {
    font-family: boldFont;
}

.text-success {
    text-align: center;
    color: #28a745;
}

.text-regular {
    font-family: regularFont;
}

.text-center {
    text-align: center;
}

.container {
    padding: 20px !important;
    height: 100%;
}

.app-body {
    max-width: 500px;
    margin: 0 auto;
}

.app-footer {
    max-width: 500px;
    margin-left: auto !important;
    margin-right: auto !important;
}

button {
    font-family: boldFont;
    text-transform: initial !important;
}

button:not(.radius-inline) {
    border-radius: 25px !important;
}

a {
    text-decoration: underline;
}

.app-container {
    padding: 0 20px !important;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    overflow-x: hidden;
}

.app-error-info {
    font-size: 14px;
    color: #888;
    text-align: center;
    padding: 20px;
}

.app-error-info > div {
    margin-top: 5px;
}

.app-pagination {
    font-size: 14px;
    text-align: center;
    margin-bottom: 5px;
}

.app-title {
    font-size: 18px;
    text-align: center;
    margin-bottom: 5px;
    max-width: 500px;
    margin: 0 auto;
}

.app-processing {
    font-size: 16px;
    text-align: center;
    padding: 40px 10px;
}

.app-subtitle {
    font-size: 16px;
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
}

.app-info {
    padding: 20px 0;
    text-align: center;
}

.app-clipboard {
    padding-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.app-clipboard > div {
    cursor: pointer;
    padding-bottom: 3px;
}

.app-clipboard b {
    margin-right: 5px;
}

.app-clipboard-icon {
    margin-left: 5px;
}

.app-button-element {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0 !important;
}

.app-label-selected {
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-bottom: 20px;
}

.app-label-image-selected {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-bottom: 60px;
}

.app-label-image-selected img {
    height: 28px;
}

.app-video {
    text-align: center;
    padding: 20px 0 0;
}

.app-image {
    text-align: center;
    padding: 40px 0 20px;
}

.app-image img {
    width: 200px;
    max-width: 100%;
}

.app-button-link {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
}

.app-button-link button {
    width: 100%;
    max-width: 200px;
}

.app-app-links {
    gap: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
}

.app-app-links > div {
    width: 100%;
    max-width: 200px;
}

.app-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 0 20px;
}

.app-footer > div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.app-footer button svg:first-child {
    margin-right: 7px;
}

.app-footer button {
    width: 100%;
    margin: 5px 0;
    font-size: 16px !important;
    height: 40px;
}

.app-margin-space {
    margin: 20px 0;
}

.form-row {
    padding: 5px 0;
    position: relative;
}

.form-row-label {
    padding: 5px 0 0;
}

.form-row-label .form-row-title {
    margin-bottom: 0 !important;
}

.form-row-title {
    margin-bottom: 5px;
    display: flex;
}

.form-row-title-parent {
    margin-bottom: 5px;
    display: flex;
    font-family: boldFont;
    font-size: 15px;
}

.form-row-photo-caption {
    margin: 15px 0 -5px;
    text-align: center;
}

.form-row .v-input:not(.form-row-mobile-phone-number):not(.input-theme-light) {
    padding: 0 !important;
    margin: 0 !important;
}

.form-row .v-input.form-row-mobile-phone-number {
    padding: 0 0 0 98px !important;
    margin: 0 !important;
}

.form-row
    > div:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(
        .form-row-field-slider-horizontal
    ):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
}

.form-row
    .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(
        .form-row-field-slider-horizontal
    ):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group)
    .v-input__control {
    margin: 0 !important;
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
}

.form-row
    .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(
        .form-row-field-slider-horizontal
    ):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group)
    .v-input__slot {
    margin: 0 !important;
    min-height: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    box-shadow: none !important;
    outline: none !important;
}

.form-row .v-input:not(.input-theme-light) .v-input__slot {
    background-color: #fff !important;
}

.form-row .v-text-field--outline > .v-input__control > .v-input__slot {
    background-color: #fff !important;
}

.form-row .v-select--chips .v-input__slot {
    padding: 5px !important;
}

.form-row
    .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(
        .form-row-field-slider-horizontal
    ):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group)
    input {
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
}

.form-row
    .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(
        .form-row-field-slider-horizontal
    ):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group)
    .v-input__append-inner {
    margin-top: 7px !important;
}

.form-row .v-input--radio-group .v-input__slot {
    border-radius: 4px;
    padding: 10px;
}

.form-row .v-input--radio-group .v-input__control {
    min-width: 100%;
}

.form-row textarea {
    padding: 12px;
    min-height: 100px;
}

.select-search-title {
    justify-content: center;
    font-family: boldFont;
    padding-bottom: 0;
}

.select-search-list-search {
    font-size: 14px;
}

.select-search-list {
    height: 55vh;
    overflow: auto;
}

.select-search-list > div {
    cursor: pointer;
    padding: 5px;
}

.select-search-list-center > div {
    justify-content: center;
}

.select-search-list > div.active {
    background-color: #ddd;
    border-radius: 5px;
}

.form-row-field-textarea-large {
    height: 180px;
}

.form-row .v-autocomplete .v-select__slot > input {
    pointer-events: none !important;
}

.form-row .v-select__selections {
    padding: 0 !important;
}

.form-row .v-select__selection--comma {
    margin: 0 !important;
}

.form-row-input-password input {
    padding-right: 20px !important;
}

.form-row-password-icon {
    position: absolute;
    top: 40px;
    right: 10px;
    cursor: pointer;
    color: #888;
}

.form-row-mobile-phone-indicative {
    position: absolute;
    left: 0;
    bottom: 5px;
    width: 90px;
    z-index: 1;
}

.form-row-mobile-phone-indicative .v-input__slot {
    padding: 0 5px;
}

.form-row-field-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.form-row-field-buttons > div {
    flex: 50%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-row-field-buttons > div:nth-child(odd) {
    justify-content: flex-end;
}

.form-row-field-buttons > div:nth-child(even) {
    justify-content: flex-start;
}

.form-row-field-button {
    width: 15vh;
    height: 15vh;
    opacity: 0.6;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.form-row-field-buttons-list {
    flex-direction: column;
}

.form-row-field-buttons-list > div {
    width: 100%;
    flex: 100%;
    padding: 0;
    margin-bottom: 15px;
}

.form-row-field-buttons-list .form-row-field-button {
    width: 100%;
    height: auto;
    justify-content: flex-start;
    opacity: 1;
    text-align: left;
    background-color: #2e2e2e;
    color: #fff;
    border-radius: 4px;
    padding: 10px;
}

.form-row-field-buttons-list .form-row-field-button-active {
    opacity: 0.6 !important;
}

.form-row-field-button-html > div {
    font-size: 11px;
}

.form-row-field-button-space {
    margin-left: 15px;
}

.form-row-field-button-slider {
    width: 100%;
    height: 100%;
}

.form-row-field-button > img {
    height: 35%;
}

.form-row-field-button span {
    font-size: 20px;
    font-family: boldFont;
}

.form-row-field-button label {
    font-size: 20px;
}

.form-row-field-button > img {
    height: 35%;
}

.form-row-field-button-active {
    opacity: 1 !important;
}

.form-row-field-slider-horizontal {
    width: calc(100% - 4vh);
    margin: 0 auto;
}

.form-row-field-slider-horizontal .vueperslides__parallax-wrapper {
    pointer-events: none;
}

.form-row-field-slider-horizontal .vueperslides__arrow svg {
    width: 2.8em;
    stroke: #506860;
    outline: none;
    stroke-width: 1 !important;
}

.form-row-field-slider-horizontal .vueperslides__arrow--prev {
    left: -11.5% !important;
}

.form-row-field-slider-horizontal .vueperslides__arrow--next {
    right: -11.5% !important;
}

.form-row-field-slider-horizontal .vueperslide {
    transform: scale(0.8);
}

.form-row-field-slider-horizontal .vueperslide--active {
    transform: scale(1);
}

.form-row .v-select .v-input__icon svg {
    height: 16px;
}

.v-dialog {
    margin: 0 auto !important;
}

.checkbox-container {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.checkbox-container.disabled {
    pointer-events: none;
    opacity: 0.3;
}

.checkbox-container-box {
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 22px;
    width: 22px;
    max-width: 22px;
    min-height: 22px;
    height: 22px;
    max-height: 22px;
    border: 1px solid #fff;
    border-radius: 4px;
    font-size: 12px;
}

.v-select-list .v-list__tile__title {
    display: flex;
    white-space: initial;
    overflow: initial;
    height: auto;
    min-height: 24px;
}

.component-select-close {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px;
    margin: -10px 0;
    color: #888;
}

.app-buttons-flex {
    padding-top: 20px;
}

.app-buttons-flex > div {
    width: calc(50% - 20px);
    margin: 10px;
    height: 120px;
    font-family: boldFont;
    text-transform: initial;
    font-size: 18px;
    border-radius: 25px;
    cursor: pointer;
    text-align: center;
}

.app-buttons-flex-small > div {
    min-height: 60px;
    font-size: 12px;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
}

.app-buttons-flex-small > div > div {
    font-size: 12px !important;
}

.app-buttons-flex-buttons-background {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.app-buttons-flex-buttons-background > div {
    margin: 0 5px;
    padding: 10px;
    width: 19vh;
    height: 19vh;
    font-size: 13px;
}

.app-buttons-cols {
    display: flex;
    flex-wrap: wrap;
}

.app-buttons-cols-item {
    max-width: calc(50% - 10px);
}

.app-buttons-cols-item > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 10px;
    padding: 5px;
}

.app-buttons-cols-item span {
    font-size: 18px;
}

.app-button-card {
    flex-direction: column;
}

.app-button-card > div:first-child {
    font-size: 15px;
}

.app-cards-wrap {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
}

@media (max-width: 400px) {
    .app-cards-wrap {
        grid-template-columns: 1fr;
    }
}

.app-cards-wrap > div {
    padding: 5px;
}

.app-cards-wrap > div > div {
    height: 100%;
    margin-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.app-cards-wrap > div > div > div:first-child {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.app-cards-wrap .card-title {
    font-size: 16px;
    line-height: 20px;
    height: 100%;
}

.app-cards-wrap .card-price {
    padding-top: 5px;
    font-size: 22px;
}

.app-cards-item > div {
    border-radius: 25px;
    padding: 10px;
    margin-bottom: 20px;
}

.card-title {
    font-family: boldFont;
    font-size: 22px;
    text-align: center;
}

.card-price {
    font-family: boldFont;
    font-size: 18px;
}

.card-price span {
    font-size: 14px;
}

.card-info {
    padding-top: 5px;
}

.card-info-title {
    font-family: boldFont;
}

.card-button {
    display: flex;
    justify-content: center;
    padding-top: 5px;
}

.app-step-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}

.app-step-tabs > div {
    padding: 5px 5px 0;
    width: 100%;
}

.app-step-tabs > div > div {
    width: 100%;
    border-bottom: 1px solid;
    text-align: center;
    padding-bottom: 5px;
}

.tags-input-wrapper-default {
    padding: 5px;
}

.tags-input-badge-selected-default {
    background-color: #e1e1e1;
    color: #555;
    padding: 8px 22px 8px 12px;
    font-size: 12px;
    margin: 2.5px !important;
}

.tags-input-remove:before,
.tags-input-remove:after {
    background-color: #888;
}

.tags-input-remove {
    right: 6px;
    top: 7px;
    padding: 8px;
}

.tags-input-remove:before,
.tags-input-remove:after {
    background-color: #888;
    background: #888;
}

.typeahead-badges {
    margin-bottom: 0;
}

.app-footer-message {
    text-align: center;
    padding-bottom: 20px;
}

.app-button-top-back {
    padding: 40px 0 5px;
    text-transform: lowercase;
    display: flex;
    align-items: center;
    font-size: 11px;
}

.app-button-top-back span {
    margin-top: -2px;
    margin-left: 5px;
}

.form-row-datepicker-inline {
    display: flex;
    background-color: #fff;
    color: #000;
}

.form-row-datepicker-inline .vue-scroll-picker {
    margin: 0 10px;
}

.form-row-datepicker-inline .vue-scroll-picker-item {
    height: 30px;
    line-height: 30px;
}

.form-row-datepicker-inline .vue-scroll-picker-layer .top,
.form-row-datepicker-inline .vue-scroll-picker-layer .bottom {
    border-color: #d0e5df;
}

.datepicker-theme-dark {
    background-color: #000;
    color: #fff;
}

.datepicker-theme-dark .vue-scroll-picker-layer .top,
.datepicker-theme-dark .vue-scroll-picker-layer .bottom {
    border-color: #000;
}

.datepicker-theme-dark .vue-scroll-picker-layer .top {
    background: linear-gradient(180deg, #000 10%, rgba(0, 0, 0, 0.7));
}

.datepicker-theme-dark .vue-scroll-picker-layer .bottom {
    background: linear-gradient(0deg, #000 10%, rgba(0, 0, 0, 0.7));
}

/* Json classes */
.app-container-adjust-content {
    height: 100%;
}

.app-container-adjust-content .app-content {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.app-container-adjust-content .app-body {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.app-container-adjust-content .app-body-div-container {
    width: 100%;
}

.app-container-adjust-content .app-margin-space {
    width: 100%;
}

.app-container-adjust-content .app-subscription-container {
    width: 100%;
}

.app-container-adjust-content .app-footer {
    width: 100%;
}

.app-container-step-background {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0 -20px;
    padding: 0 20px;
}

.input-theme-light {
    margin-bottom: 10px !important;
}

.input-theme-light .v-input__slot {
    border-width: 1px !important;
    font-size: 13px;
    background-color: transparent !important;
}

.input-theme-light .v-label {
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 1px;
}

.input-theme-light .v-input__slot:before,
.input-theme-light .v-input__slot:after {
    border-color: #d0e5df !important;
}

.input-theme-light .primary--text {
    color: rgba(0, 0, 0, 0.54) !important;
    caret-color: rgba(0, 0, 0, 0.54) !important;
}

.input-theme-light.v-textarea {
    border: 1px solid #d0e5df;
    border-radius: 15px;
    padding: 0;
}

.input-theme-light.v-textarea textarea {
    resize: none !important;
}

.input-theme-light.v-textarea .v-input__slot:before,
.input-theme-light.v-textarea .v-input__slot:after {
    display: none;
}

.form-row .input-theme-only-bottom.v-text-field--outline > .v-input__control > .v-input__slot {
    background-color: transparent !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
    border-color: #2e2e2e !important;
    color: #fff !important;
}

.form-row .input-theme-only-bottom.v-textarea {
    border-color: #2e2e2e !important;
}

.form-row .input-theme-only-bottom.v-textarea .v-input__control {
    background-color: #2e2e2e !important;
    border-radius: 13px;
}

.form-row .input-theme-only-bottom.v-textarea textarea {
    color: #fff !important;
}

.form-row .input-theme-only-bottom.v-textarea textarea::placeholder {
    color: #fff !important;
}

.input-theme-only-bottom input {
    color: #fff !important;
}

.input-theme-only-bottom input::placeholder {
    color: #fff !important;
}

.buttons-theme-light button {
    box-shadow: none !important;
}

.buttons-theme-small button {
    max-width: 250px;
}

.form-row .select-theme-dark.v-text-field--outline > .v-input__control > .v-input__slot {
    background-color: #2e2e2e !important;
}

.form-row .select-theme-dark .v-icon {
    color: #fff !important;
}

.form-row .select-theme-dark .v-select__selections {
    color: #fff !important;
}

/* Montserrat light */
.app-container-font-montserrat-light {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .form-row-title {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .application {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .swal2-container {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .text-bold {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .text-regular {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .app-subtitle {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .app-info {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .app-label-selected {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light button {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-tabs > div {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-arrows-title {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-arrows-top {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-arrows-bottom {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .form-row-title-parent {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .form-row .input-slider-legend-value-circle {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-buttons-flex > div {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .form-row-field-buttons span {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .select-search-title {
    font-family: mediumMontserratFont;
}

.app-container-font-montserrat-light .app-buttons-cols-item {
    font-family: lightMontserratFont;
}

.app-container-font-montserrat-light .app-buttons-cols-item span {
    font-family: mediumMontserratFont;
}

/* Montserrat */
.app-container-font-montserrat {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .form-row-title {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .application {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .swal2-container {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .text-bold {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .text-regular {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .app-subtitle {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .app-info {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .app-label-selected {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat button {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-tabs > div {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-arrows-title {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-arrows-top {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-arrows-bottom {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .form-row-title-parent {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .form-row .input-slider-legend-value-circle {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-buttons-flex > div {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .form-row-field-buttons span {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .select-search-title {
    font-family: boldMontserratFont;
}

.app-container-font-montserrat .app-buttons-cols-item {
    font-family: regularMontserratFont;
}

.app-container-font-montserrat .app-buttons-cols-item span {
    font-family: boldMontserratFont;
}

/* Roboto */
.app-container-font-roboto {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .form-row-title {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .application {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .swal2-container {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .text-bold {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .text-regular {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .app-subtitle {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .app-info {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .app-label-selected {
    font-family: regularRobotoFont;
}

.app-container-font-roboto button {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-tabs > div {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-arrows-title {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-arrows-top {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-arrows-bottom {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .form-row-title-parent {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .form-row .input-slider-legend-value-circle {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-buttons-flex > div {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .form-row-field-buttons span {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .select-search-title {
    font-family: boldRobotoFont;
}

.app-container-font-roboto .app-buttons-cols-item {
    font-family: regularRobotoFont;
}

.app-container-font-roboto .app-buttons-cols-item span {
    font-family: boldRobotoFont;
}

/* MyriadPro */
.app-container-font-myriadpro {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .form-row-title {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .application {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .swal2-container {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .text-bold {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .text-regular {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .app-subtitle {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .app-info {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .app-label-selected {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro button {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-tabs > div {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-arrows-title {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-arrows-top {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-arrows-bottom {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .form-row-title-parent {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .form-row .input-slider-legend-value-circle {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-buttons-flex > div {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .form-row-field-buttons span {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .select-search-title {
    font-family: boldMyriadProFont;
}

.app-container-font-myriadpro .app-buttons-cols-item {
    font-family: regularMyriadProFont;
}

.app-container-font-myriadpro .app-buttons-cols-item span {
    font-family: boldMyriadProFont;
}

/* Antom */
.app-container-font-antom .text-bold {
    font-family: boldAntomFont;
}

.app-container-font-antom .text-bold.app-subtitle {
    font-family: regularFont;
}

.app-container-font-antom button {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-tabs > div {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-arrows-title {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-arrows-top {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-arrows-bottom {
    font-family: boldAntomFont;
}

.app-container-font-antom .form-row-title-parent {
    font-family: boldAntomFont;
}

.app-container-font-antom .form-row .input-slider-legend-value-circle {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-buttons-flex > div {
    font-family: boldAntomFont;
}

.app-container-font-antom .form-row-field-buttons span {
    font-family: boldAntomFont;
}

.app-container-font-antom .select-search-title {
    font-family: boldAntomFont;
}

.app-container-font-antom .app-buttons-cols-item span {
    font-family: boldAntomFont;
}

/* poppins */
.app-container-font-poppins {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .form-row-title {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .application {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .swal2-container {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .text-bold {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .text-regular {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .app-subtitle {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .app-info {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .app-label-selected {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins button {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-tabs > div {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-arrows-title {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-arrows-top {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-arrows-bottom {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .form-row-title-parent {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .form-row .input-slider-legend-value-circle {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-buttons-flex > div {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .form-row-field-buttons span {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .select-search-title {
    font-family: boldPoppinsFont;
}

.app-container-font-poppins .app-buttons-cols-item {
    font-family: regularPoppinsFont;
}

.app-container-font-poppins .app-buttons-cols-item span {
    font-family: boldPoppinsFont;
}

/* stara */
.app-container-font-stara {
    font-family: regularStaraFont;
}

.app-container-font-stara .form-row-title {
    font-family: regularStaraFont;
}

.app-container-font-stara .application {
    font-family: regularStaraFont;
}

.app-container-font-stara .swal2-container {
    font-family: regularStaraFont;
}

.app-container-font-stara .text-bold {
    font-family: boldStaraFont;
}

.app-container-font-stara .text-regular {
    font-family: regularStaraFont;
}

.app-container-font-stara .app-subtitle {
    font-family: regularStaraFont;
}

.app-container-font-stara .app-info {
    font-family: regularStaraFont;
}

.app-container-font-stara .app-label-selected {
    font-family: regularStaraFont;
}

.app-container-font-stara button {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-tabs > div {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-arrows-title {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-arrows-top {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-arrows-bottom {
    font-family: boldStaraFont;
}

.app-container-font-stara .form-row-title-parent {
    font-family: boldStaraFont;
}

.app-container-font-stara .form-row .input-slider-legend-value-circle {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-buttons-flex > div {
    font-family: boldStaraFont;
}

.app-container-font-stara .form-row-field-buttons span {
    font-family: boldStaraFont;
}

.app-container-font-stara .select-search-title {
    font-family: boldStaraFont;
}

.app-container-font-stara .app-buttons-cols-item {
    font-family: regularStaraFont;
}

.app-container-font-stara .app-buttons-cols-item span {
    font-family: boldStaraFont;
}

/* custom1 */
.app-container-font-custom1 {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .form-row-title {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .application {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .swal2-container {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .text-bold {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .text-regular {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .app-subtitle {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .app-info {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .app-label-selected {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 button {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-tabs > div {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-arrows-title {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-arrows-top {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-arrows-bottom {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .form-row-title-parent {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .form-row .input-slider-legend-value-circle {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-buttons-flex > div {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .form-row-field-buttons span {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .select-search-title {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 .app-buttons-cols-item {
    font-family: regularCustom1Font;
}

.app-container-font-custom1 .app-buttons-cols-item span {
    font-family: boldCustom1Font;
}

.app-container-font-custom1 button,
.app-container-font-custom1 input,
.app-container-font-custom1 optgroup,
.app-container-font-custom1 select,
.app-container-font-custom1 textarea {
    font-family: regularCustom1Font;
}

.sequra-checkout {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 100000;
    overflow: auto;
}

.sequra-checkout iframe {
    display: block !important;
}
</style>

<script>
import VuebaseLayout from './layouts/VuebaseLayout'
import Utils from './services/Utils'

export default {
    name: 'App',
    components: {
        VuebaseLayout,
    },
    computed: {
        component() {
            return VuebaseLayout
        },
    },
    beforeMount: function () {
        Utils.initialize()
    },
}
</script>
